module.exports = "/_next/static/images/ThePayoff-sm@2x-07280b171820dad36acd05f5209fd87c.png";